export enum UserType {
  BUYER = 'buyer',
  AGENT = 'agent'
}

export interface RegistrationState {
  userType: UserType
  phoneNumber: string
  verifiedData: VerifyIdentityContent | null
}

export interface RegisterFormData {
  role: string
  nationalId: string
  fullName: string
  phone: string
  email: string
  password: string
  confirmPassword: string
  acceptedTermsAndConditions: boolean
}

export interface RegisterPayload {
  fullName: string
  email: string
  password: string
  phone: string
  role: string
  verificationId: string
  acceptedTermsAndConditions: boolean
}

export interface VerifyIdentityPayload {
  nationalId: string
}

export interface VerifyIdentityContent {
  id: string
  nationalId: string
  kraPin: string
  fullName: string
  createdBy: string
  createdDate: string
  lastModifiedBy: string
  lastModifiedDate: string
}

export interface VerifyIdentityResponse {
  success: boolean
  message: string
  content: VerifyIdentityContent
}

export interface RegisterResponse {
  id_token: string
}
